module.exports = __webpack_public_path__ + "img/black-logo.7e60c101.svg";